import { Input } from '#shared/Input/Input';
import { produce } from 'immer';
import { useEffect } from 'react';
import { useDraftChartForEdit } from '../Edit/useDraftChartForEdit';
import { Item, Label, Unit } from '../MemberInfo/components/styles';
import { useRoundInfoState } from '../states/roundInfoState';
import { Inbody } from '../types';
import { BeforeAfterPhoto } from './BeforeAfterPhoto';
import { RoundInfoPainParts } from './RoundInfoPainParts';

interface Item {
  view: string;
  name: string | string[];
  unit?: string;
}

export const RoundInfoForm = () => {
  const { roundInfo, setRoundInfo } = useRoundInfoState();

  const itemList: Item[] = [
    {
      view: '몸무게',
      name: 'weight',
      unit: 'kg'
    },
    {
      view: '체지방률',
      name: 'bodyFatMass',
      unit: '%'
    },
    {
      view: '골격근량',
      name: 'skeletalMuscleMass',
      unit: 'kg'
    }
  ];

  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const name = e.target.name as keyof Inbody;

    if (roundInfo === null) {
      const newRoundInfo = {
        [name]: Number(e.target.value)
      } as unknown as Inbody;

      setRoundInfo(newRoundInfo);
    } else {
      setRoundInfo(
        produce(roundInfo, draft => {
          draft[name] = Number(e.target.value);
        })
      );
    }
  };

  const { draftChart } = useDraftChartForEdit();

  useEffect(() => {
    if (draftChart) {
      setRoundInfo({
        weight: draftChart.inbody?.weight || 0,
        bodyFatMass: draftChart.inbody?.bodyFatMass || 0,
        skeletalMuscleMass: draftChart.inbody?.skeletalMuscleMass || 0
      });
    }
  }, [draftChart]);

  return (
    <div>
      {itemList.map(item => {
        const getValue = () => {
          if (!roundInfo) return '';

          if (roundInfo[item.name as keyof Inbody] > 0) {
            return roundInfo[item.name as keyof Inbody];
          } else {
            return '';
          }
        };

        return (
          <Item
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
            key={item.view}
          >
            <Label>{item.view}</Label>

            <div className="flex gap-4 items-center">
              <Input
                name={item.name as string}
                placeholder="-"
                style={{
                  textAlign: 'center',
                  width: '100%',
                  height: '100%',
                  padding: '0'
                }}
                value={getValue()}
                inputWrapperStyle={{ width: '80px', height: '35px' }}
                onChange={onInputChange}
              />
              <Unit>{item.unit}</Unit>
            </div>
          </Item>
        );
      })}
      <RoundInfoPainParts />

      <BeforeAfterPhoto />
    </div>
  );
};
